<td class="month-column">
  {{ formattedMonth(requirement.month) }}
</td>
<td class="mr-auto">
  <span class="mr-2 circle-indicator" [ngClass]="{
    'text-danger': requirement.status === 'failed',
    'text-warning': requirement.status === 'unprocessed' || requirement.status === 'needed',
    'text-success': requirement.status === 'processing' || requirement.status === 'complete'
  }">
    <i class="fa fa-circle" *ngIf="requirement.status !== 'processing' && requirement.status !== 'complete'"></i>
    <i class="fa fa-check" *ngIf="requirement.status === 'processing' || requirement.status === 'complete'"></i>
  </span>

  {{ formattedStatus(requirement.status) }}
</td>
<td class="text-right">

  <a *ngIf="requirement.documentId"
     class="req-doc-view align-middle"
     [ngClass]="{'disabled': !docIsClean}"
     [attr.title]="viewTitle"
     [attr.href]="viewHref"
     (click)="openDocument(requirement.documentId)"
  >
    View
  </a>

</td>
